const HALITRADE_PUBLIC_URL = (process.env.REACT_APP_HALITRADE_PUBLIC_URL || 'https://halitrade.com')
  .replace(/\/$/, '');

/** When on localhost, use current origin so "Get Started" stays local. Otherwise use HALITRADE_PUBLIC_URL. */
export const getAppBaseUrl = () => {
  if (typeof window !== 'undefined' && /^(localhost|127\.0\.0\.1)$/.test(window.location.hostname)) {
    return window.location.origin;
  }
  return HALITRADE_PUBLIC_URL;
};

export const getHalitradeUrl = (path = '') => {
  const base = getAppBaseUrl();
  if (!path) return base;
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${base}${normalized}`;
};

/** Login URL for CTAs (Get Started). Stays on localhost in dev, uses halitrade.com in production. */
export const getLoginUrl = (query = 'tenant=haliflow') => {
  const base = getAppBaseUrl();
  return `${base}/login${query ? `?${query}` : ''}`;
};

/** EVA full app URL. In dev: eva-full runs on port 5173 (Docker). Override with REACT_APP_EVA_APP_URL. */
export const getEvaAppUrl = () => {
  const url = process.env.REACT_APP_EVA_APP_URL;
  if (url && url.trim()) return url.trim().replace(/\/$/, '');
  if (typeof window !== 'undefined' && /^(localhost|127\.0\.0\.1)$/.test(window.location.hostname)) {
    return 'http://localhost:5173';
  }
  return 'https://eva.halisoft.biz';
};
